/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
import React, {Fragment, useState, useEffect} from 'react'
import {Button, Form} from 'react-bootstrap'
import '../Overview.css'
import Modal from 'react-bootstrap/Modal'
import Forms from './Form'
import UserService from '../../../../../services/user'
import useServices from '../../../../../utils/hooks/useServices'
import Dropdown from 'react-bootstrap/Dropdown'
import {toast} from 'react-toastify'
import Spinner from 'react-bootstrap/Spinner'
import {InitProfileData} from '../initProfileData'
import MasterServices from '../../../../../services/master'
import {useSearchParams} from 'react-router-dom'
import {PageTitle} from '_metronic/layout/core'
import {dateFormat} from 'thesis-and-dissertations/helpers/helper'

const Education = () => {
  const [searchParams] = useSearchParams()
  const [show, setShow] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [formValue, setFormValue] = useState<any>({})
  const [submit, setSubmit] = useState(false)
  const [data, setData] = useState<any>({})
  const [dataUser, loading, makeItEmpty, triggerRefresh] = useServices(
    searchParams.get('alumni') ? MasterServices.showUser : UserService.getProfile,
    searchParams.get('alumni')
  )
  const [loadingDelete, setLoadingDelete] = useState(false)

  useEffect(() => {
    if (searchParams.get('alumni')) {
      setData(dataUser?.data)
    } else {
      setData(dataUser)
    }
  }, [dataUser])

  useEffect(() => {
    return () => {
      makeItEmpty()
    }
  }, [])

  const toggle = () => {
    if (show) {
      setIsEdit(false)
      setFormValue({})
    }
    setShow(!show)
  }

  const onChange = (e: any) => {
    const {name, value} = e.target

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleDelete = async (id: any) => {
    try {
      if (!window.confirm('Yakin Ingin Menghapus Pendidikan ?')) {
        return
      }
      setLoadingDelete(true)
      setSubmit(true)

      await UserService.deleteEducation(id).then(() => {
        toast.success('Pendidikan berhasil dihapus')
        triggerRefresh()
      })
    } catch (error) {
      toast.success('Pendidikan gagal dihapus')
    } finally {
      setSubmit(false)
      setLoadingDelete(false)
    }
  }
  return (
    <div>
      <Modal show={show} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Form' : 'Form'} Pendidikan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Forms
            onChange={onChange}
            editFormValue={formValue}
            toggle={toggle}
            getData={() => {
              makeItEmpty()
              setTimeout(() => {
                triggerRefresh()
              }, 1000)
            }}
          />
        </Modal.Body>
      </Modal>
      <div className='row'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-6'>
              {localStorage.getItem('role') == 'Alumni' && (
                <PageTitle
                  breadcrumbs={[
                    {
                      title: 'Dashboard',
                      path: '/dashboard',
                      isSeparator: false,
                      isActive: false,
                    },
                    {
                      title: '/',
                      path: '',
                      isSeparator: false,
                      isActive: false,
                    },
                  ]}
                >
                  Pendidikan
                </PageTitle>
              )}
              <h4> Pendidikan</h4>
            </div>
            <div className='col-md-6'>
              {!searchParams.get('alumni') && (
                <Button
                  onClick={toggle}
                  className='btn btn-primary btn-sm btn-add'
                  style={{float: 'right'}}
                >
                  Tambah
                </Button>
              )}
            </div>
          </div>
        </div>
        <div className='col-md-12 d-grid gap-10'>
          <div style={{textAlign: 'center'}}>
            {loading && (
              <Spinner animation='border' role='status' style={{height: '100px', width: '100px'}} />
            )}
            {!loading && data?.educations?.length === 0 && <h3>Tidak ada data Pendidikan </h3>}
          </div>
          <div className='d-grid gap-10'>
            {data?.educations?.map((item: any, key: any) => {
              return (
                <Fragment key={key}>
                  <div className='card-custom'>
                    <div className='row'>
                      <div className='col-md-6 p-2'>
                        <h5>{item.university?.universities_name}</h5>
                      </div>
                      {!searchParams.get('alumni') && (
                        <div className='col-md-6'>
                          <Dropdown>
                            <Dropdown.Toggle
                              id='dropdown-basic'
                              style={{float: 'right'}}
                              className='btn btn-primary btn-sm'
                            >
                              Aksi
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href='#/action-1'
                                onClick={() => {
                                  setIsEdit(true)
                                  setFormValue({
                                    universities: item?.university?.universities_name,
                                    degrees: item?.degree?.degrees_name,
                                    majors: item?.major?.majors_name,
                                    start_date: item?.user_educations_start_date,
                                    end_date: item?.user_educations_end_date,
                                    gpa: item?.user_educations_gpa,
                                    gpa_max: item?.user_educations_gpa_max,
                                    description: item?.user_educations_description,
                                    user_educations_id: item?.user_educations_id,
                                    rowDetail: item,
                                  })
                                  toggle()
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                href='#/action-2'
                                onClick={() => {
                                  handleDelete(item?.user_educations_id)
                                }}
                              >
                                Hapus
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      )}
                      <div className='col-md-12'>
                        <div className='row'>
                          <div className='col-md-6 p-2'>
                            <p>Jenjang Pendidikan</p>
                            <p className='fw-bold'>{item.degree?.degrees_name}</p>
                          </div>
                          <div className='col-md-6 p-2'>
                            <p>Jurusan</p>
                            <p className='fw-bold'>{item.major?.majors_name}</p>
                          </div>
                          <div className='col-md-6 p-2'>
                            <p>Tahun Masuk</p>
                            <p className='fw-bold'>
                              {item.user_educations_start_date
                                ? dateFormat(item.user_educations_start_date)
                                : '-'}
                            </p>
                          </div>
                          <div className='col-md-6 p-2'>
                            <p>Tahun Lulus</p>
                            <p className='fw-bold'>
                              {item.user_educations_end_date
                                ? dateFormat(item?.user_educations_end_date)
                                : 'Dalam masa studi'}
                            </p>
                          </div>
                          <div className='col-md-12 p-2'>
                            <p>Nilai</p>
                            <p className='fw-bold'>
                              {item.user_educations_gpa || '-'}
                              {item.user_educations_gpa_max && ` / ${item.user_educations_gpa_max}`}
                            </p>
                          </div>
                          <div className='col-md-12 p-2'>
                            <p>Deskripsi</p>
                            <p className='fw-bold'>{item.user_educations_description || '-'}</p>
                          </div>

                          {(item?.certificate_url_full || item?.transcript_url_full) &&
                          item?.user_educations_end_date ? (
                            <div className='col-md-12 p-2'>
                              <p>Dokumen Pendukung</p>
                              {item.certificate_url_full ? (
                                <a
                                  href={item?.certificate_url_full}
                                  target='_blank'
                                  className='btn btn-primary btn-sm'
                                  rel='noreferrer'
                                >
                                  Ijazah
                                </a>
                              ) : null}{' '}
                              {item?.transcript_url_full ? (
                                <a
                                  href={item?.transcript_url_full}
                                  target='_blank'
                                  className='btn btn-primary btn-sm'
                                  rel='noreferrer'
                                >
                                  Transkrip Nilai
                                </a>
                              ) : null}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </Fragment>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Education
